import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaDownload } from 'react-icons/fa';
import './Catalogue.css';
import { useTranslation } from 'react-i18next';


const CatalogueDownload = () => {
    const { t } = useTranslation();
  return (
    <div
      style={{
        backgroundColor: '#3E4856',
        color: 'white',
        padding: '80px 0',
        width: '100vw',
        marginLeft: 'calc(-50vw + 50%)', // Forces true full-width from center-aligned parent
      }}
    >
      <Container fluid className="px-5">
        <Row className="align-items-center justify-content-between">
          <Col md={8}>
          <h1
  style={{
    fontSize: '2rem',
    fontWeight: '700',
    margin: 0,
  }}
>
               {t('Découvrez_Nos_Produits')}
               {/* {t('')} */}

</h1>


          </Col>
          <Col md={4} className="text-md-end mt-4 mt-md-0">
         <a
  href="/catalogue"
  className="download-btn"
>
  <FaDownload />
               {t('Téléchargez_le_catalogue')}
</a>



          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CatalogueDownload;
